import profil from '../assets/profile.png';
import FooterRelative from '../components/FooterRelative';
import Model3D from '../components/Model3d';
function Apropos (){
    return (
        <div>
            <div className="container" id="containerApropos">
                <div className="headerContainerAPropos">      
                        <div className="headerContainerLeft">
                            <h2>Raphaël Alcantara</h2>
                            <p>Motion Designer </p>
                        </div>
                        <div className="headerContainerRight">
                            <div className="circle" style={{
                                backgroundImage: `url(${profil})`,
                            }}></div>
                        
                        </div>

                </div>
                            <Model3D/>
         
                <h2>Qui-suis-je?</h2>
                <p>Je m'appelle Raphaël Alcantara, j'ai 23 ans. Ancien élève en MMI, actuellement étudiant à l'école les Gobelins. Je suis passionné par le motion design et l'animation. 
                    Curieux et touche-à-tout, j'aime explorer de nouvelles techniques et donner vie aux visuels à travers des animations dynamiques et créatives.</p>

                <h2>Mes compétences</h2>

                <div className="cardContainer">
                    <div className="card">
                        <div className="cardHeader">
                        <h3>Design</h3>
                        </div>
                        <div className="cardBody">
                        <p>Maîtrise de la suite Adobe Illustrator, Photoshop, After Effects, InDesign et Figma.</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="cardHeader">
                        <h3>Technologies</h3> 
                        </div>
                        <div className="cardBody">
                    <p> HTML, CSS, Git, JavaScript, React, PHP, MySQL, Sass, Bootstrap, Java et C#. </p>   
                    </div>
                </div>
                </div>
            </div>
            <FooterRelative/>
        </div>
    );
}

export default Apropos;